import produce from 'immer';
import { CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS } from '../constants/actions/accountActions';
import { CLOSE_ALL_MODALS_FULFILLED } from '../constants/actions/modalActions';
import { FETCH_PAGE_FULFILLED } from '../constants/actions/pageActions';
import {
	CREATE_PAYMENT_CARD,
	CREATE_PAYMENT_CARD_ERROR,
	CREATE_PAYMENT_CARD_PENDING,
	DELETE_PAYMENT_CARD_FULFILLED,
	PAYMENT_ERROR,
	PAYMENT_FULFILLED,
	PAYMENT_PENDING,
} from '../constants/actions/paymentActions';
import {
	ADD_CUSTOMS_INFORMATION,
	ADD_CUSTOMS_INFORMATION_FAILED,
	ADD_CUSTOMS_INFORMATION_FULFILLED,
} from '../constants/actions/shipmentsActions';
import { ADD_USER_EMAIL_TOKENCLEAR } from '../constants/actions/userActions';
import {
	ADD_USER_EMAIL_ERROR,
	ADD_USER_EMAIL_FULFILLED,
	ADD_USER_EMAIL_PENDING,
	FORGOT_PASSWORD_ERROR,
	FORGOT_PASSWORD_PENDING,
	FORGOT_PASSWORD_SUCCESS,
	GET_USER_PROFILE_ERROR,
	GET_USER_PROFILE_FULFILLED,
	GET_USER_PROFILE_PENDING,
	LOGIN_FAILED,
	LOGIN_LOADING,
	LOGOUT_FAILED,
	LOGOUT_FULFILLED,
	LOGOUT_LOADING,
	RESET_PASSWORD_ERROR,
	RESET_PASSWORD_PENDING,
	RESET_PASSWORD_SUCCESS,
	SET_AUDKENNI_VERIFICATION_CODE,
	SHOW_LOGIN,
	SIGN_UP_ERROR,
	SIGN_UP_PENDING,
	SIGN_UP_SUCCESS,
	UPDATE_USER_ADDRESS_ERROR,
	UPDATE_USER_ADDRESS_FULFILLED,
	UPDATE_USER_ADDRESS_PENDING,
	UPDATE_USER_PROFILE_ERROR,
	UPDATE_USER_PROFILE_FULFILLED,
	UPDATE_USER_PROFILE_PENDING,
} from '../constants/actions/userProfileActions';
import IUserProfileReducer from '../interfaces/reducers/userProfileReducer';

const initialValues: IUserProfileReducer = {
	modalSubmitError: false,
	modalSubmitErrorDetails: '',
	modalSubmitPending: false,
	userLoading: false,
	userProfile: null,
	loginLoading: false,
	loginError: false,
	loginErrorMessage: null,
	isLoggedIn: false,
	signupLoading: false,
	signupError: false,
	signupErrorMessage: '',
	signupSuccess: false,
	resetPasswordLoading: false,
	resetPasswordError: false,
	resetPasswordErrorMessage: '',
	resetPasswordSuccess: false,
	forgotPasswordLoading: false,
	forgotPasswordError: false,
	forgotPasswordErrorMessage: '',
	forgotPasswordSuccess: false,
	addEmailUserLoading: false,
	addEmailUserErrorMessage: '',
	addEmailVerificationId: '',
	userHasVerifiedEmail: null,
	audkenniVerificationCode: null,
};

const userProfileReducer = produce((draft: IUserProfileReducer, action) => {
	switch (action.type) {
		case GET_USER_PROFILE_FULFILLED: {
			draft.userLoading = false;
			draft.userProfile = action.payload.userProfile;
			if (draft.userProfile && draft.userProfile.emailVerified) {
				draft.userHasVerifiedEmail = true;
			}
			draft.isLoggedIn = true;
			break;
		}
		case GET_USER_PROFILE_PENDING: {
			draft.userLoading = true;
			break;
		}
		case GET_USER_PROFILE_ERROR: {
			draft.userLoading = false;
			draft.loginError = true;
			draft.loginLoading = false;
			break;
		}
		case UPDATE_USER_PROFILE_FULFILLED: {
			draft.isLoggedIn = true;
			draft.userProfile = action.payload.userProfile;
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = '';
			draft.modalSubmitPending = false;
			break;
		}
		case UPDATE_USER_PROFILE_PENDING: {
			draft.modalSubmitPending = true;
			break;
		}
		case UPDATE_USER_PROFILE_ERROR: {
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			draft.modalSubmitPending = false;
			break;
		}
		case DELETE_PAYMENT_CARD_FULFILLED: {
			draft.userProfile.paymentCardId = null;
			draft.userProfile.permissionToMakeAutomaticPayments = false;
			break;
		}
		case UPDATE_USER_ADDRESS_FULFILLED: {
			draft.isLoggedIn = true;
			draft.userProfile = action.payload.userProfile;
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = '';
			draft.modalSubmitPending = false;
			break;
		}
		case UPDATE_USER_ADDRESS_PENDING: {
			draft.modalSubmitPending = true;
			break;
		}
		case UPDATE_USER_ADDRESS_ERROR: {
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			draft.modalSubmitPending = false;
			break;
		}
		case ADD_CUSTOMS_INFORMATION: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			draft.modalSubmitPending = true;
			break;
		}
		case ADD_CUSTOMS_INFORMATION_FULFILLED: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			draft.modalSubmitPending = false;
			break;
		}
		case ADD_CUSTOMS_INFORMATION_FAILED: {
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			draft.modalSubmitPending = false;
			break;
		}
		case CREATE_PAYMENT_CARD: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			draft.modalSubmitPending = false;
			break;
		}
		case CREATE_PAYMENT_CARD_PENDING: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			draft.modalSubmitPending = true;
			break;
		}
		case CREATE_PAYMENT_CARD_ERROR: {
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			draft.modalSubmitPending = false;
			break;
		}
		case PAYMENT_PENDING: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			draft.modalSubmitPending = true;
			break;
		}
		case PAYMENT_FULFILLED: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			draft.modalSubmitPending = false;
			break;
		}
		case PAYMENT_ERROR: {
			draft.modalSubmitError = true;
			draft.modalSubmitErrorDetails = action.payload;
			draft.modalSubmitPending = false;
			break;
		}
		case LOGIN_LOADING: {
			draft.loginLoading = true;
			draft.loginError = false;
			draft.loginErrorMessage = null;
			draft.isLoggedIn = false;
			break;
		}
		case LOGIN_FAILED: {
			draft.loginLoading = false;
			draft.loginError = true;
			draft.loginErrorMessage = action.payload;
			draft.isLoggedIn = false;
			break;
		}
		case LOGOUT_LOADING: {
			draft.loginLoading = true;
			draft.loginError = false;
			draft.loginErrorMessage = null;
			break;
		}
		case LOGOUT_FAILED: {
			draft.loginLoading = false;
			draft.loginError = false;
			break;
		}
		case SIGN_UP_PENDING: {
			draft.signupLoading = true;
			draft.signupError = false;
			break;
		}
		case SIGN_UP_ERROR: {
			draft.signupLoading = false;
			draft.signupError = true;
			draft.signupErrorMessage = action.payload;
			break;
		}
		case SIGN_UP_SUCCESS: {
			draft.signupLoading = false;
			draft.signupError = false;
			draft.signupSuccess = true;
			break;
		}
		case FORGOT_PASSWORD_PENDING: {
			draft.forgotPasswordLoading = true;
			draft.forgotPasswordError = false;
			break;
		}
		case FORGOT_PASSWORD_ERROR: {
			draft.forgotPasswordLoading = false;
			draft.forgotPasswordError = true;
			draft.forgotPasswordErrorMessage = action.payload;
			break;
		}
		case FORGOT_PASSWORD_SUCCESS: {
			draft.forgotPasswordSuccess = true;
			draft.forgotPasswordLoading = false;
			draft.forgotPasswordError = false;
			break;
		}
		case RESET_PASSWORD_PENDING: {
			draft.resetPasswordLoading = true;
			draft.resetPasswordError = false;
			break;
		}
		case RESET_PASSWORD_ERROR: {
			draft.resetPasswordLoading = false;
			draft.resetPasswordError = true;
			draft.resetPasswordErrorMessage = action.payload;
			break;
		}
		case RESET_PASSWORD_SUCCESS: {
			draft.resetPasswordSuccess = true;
			draft.resetPasswordLoading = false;
			draft.resetPasswordError = false;
			break;
		}
		case SHOW_LOGIN: {
			draft.userLoading = false;
			draft.isLoggedIn = false;
			break;
		}
		case FETCH_PAGE_FULFILLED: {
			draft.userLoading = false;
			break;
		}
		case CHECK_PHONE_NUMBER_VERIFICATION_TOKEN_SUCCESS: {
			draft.userProfile.phoneNumberVerified = true;
			break;
		}
		case CLOSE_ALL_MODALS_FULFILLED: {
			draft.modalSubmitError = false;
			draft.modalSubmitErrorDetails = '';
			break;
		}
		case LOGOUT_FULFILLED: {
			return initialValues;
		}
		case ADD_USER_EMAIL_PENDING: {
			draft.addEmailUserLoading = true;
			draft.addEmailUserErrorMessage = '';
			draft.addEmailVerificationId = '';
			break;
		}

		case ADD_USER_EMAIL_ERROR: {
			draft.addEmailUserLoading = false;
			draft.addEmailUserErrorMessage = action.payload;
			draft.addEmailVerificationId = '';
			break;
		}

		case ADD_USER_EMAIL_FULFILLED: {
			draft.addEmailUserLoading = false;
			draft.addEmailUserErrorMessage = '';
			draft.userProfile.email = action.payload?.userEmail?.email ? action.payload?.userEmail?.email : '';
			draft.addEmailVerificationId = action.payload?.userEmail?.emailVerificationId
				? action.payload?.userEmail?.emailVerificationId
				: '';
			draft.userProfile.emailVerified = action.payload?.userEmail?.verified;

			break;
		}

		case ADD_USER_EMAIL_TOKENCLEAR: {
			draft.addEmailVerificationId = '';
			break;
		}
		case SET_AUDKENNI_VERIFICATION_CODE: {
			draft.audkenniVerificationCode = action.payload;
			break;
		}
		default:
			break;
	}
}, initialValues);

export default userProfileReducer;
